var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 340,
    viewBox: "0 0 560 340",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wood",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9b5f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#7a4528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a86a45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dialGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffd889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e0a53d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "metal",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5a524d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#2d2927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8b847d"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "mesh",
    width: 8,
    height: 8,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#201915"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.1,
    fill: "#d8c7a3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1.1,
    fill: "#d8c7a3"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grain",
    width: 120,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 40,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10 C20 4, 40 16, 60 10 S100 4, 120 10",
    stroke: "#6b3d25",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22 C20 16, 40 28, 60 22 S100 16, 120 22",
    stroke: "#b9784e",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32 C20 26, 40 38, 60 32 S100 26, 120 32",
    stroke: "#6b3d25",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.28
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 10,
    floodColor: "#000000",
    floodOpacity: 0.22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70,
    rx: 28,
    ry: 28,
    width: 520,
    height: 220,
    fill: "url(#wood)",
    stroke: "#6d3f26",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70,
    rx: 28,
    ry: 28,
    width: 520,
    height: 220,
    fill: "url(#grain)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 92,
    rx: 10,
    ry: 10,
    width: 220,
    height: 46,
    fill: "#8f603f",
    stroke: "#b98a5e",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 115,
    r: 14,
    fill: "#8a5938"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 115,
    r: 10,
    fill: "#b37a50"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 115,
    r: 16,
    fill: "#7a4b2f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 115,
    r: 11,
    fill: "#b88454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 115,
    r: 14,
    fill: "#8a5938"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 115,
    r: 10,
    fill: "#b37a50"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 86,
    width: 8,
    height: 102,
    rx: 4,
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 50,
    width: 4,
    height: 38,
    rx: 2,
    fill: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 24,
    width: 2.5,
    height: 28,
    rx: 2,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.25,
    cy: 20,
    r: 4,
    fill: "#777"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 150,
    rx: 14,
    ry: 14,
    width: 420,
    height: 110,
    fill: "url(#mesh)",
    stroke: "#a36b47",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 205,
    r: 44,
    fill: "url(#dialGlow)",
    stroke: "#a86d2f",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 205,
    r: 30,
    fill: "#231d1a",
    stroke: "#5d544f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 205,
    r: 19,
    fill: "url(#metal)",
    stroke: "#9b948d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#9c5e20",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 167,
    x2: 420,
    y2: 176
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438,
    y1: 172,
    x2: 434,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451,
    y1: 185,
    x2: 443,
    y2: 189
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458,
    y1: 205,
    x2: 449,
    y2: 205
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451,
    y1: 225,
    x2: 443,
    y2: 221
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438,
    y1: 238,
    x2: 434,
    y2: 230
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 243,
    x2: 420,
    y2: 234
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402,
    y1: 238,
    x2: 406,
    y2: 230
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389,
    y1: 225,
    x2: 397,
    y2: 221
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382,
    y1: 205,
    x2: 391,
    y2: 205
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389,
    y1: 185,
    x2: 397,
    y2: 189
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402,
    y1: 172,
    x2: 406,
    y2: 180
  })), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 205,
    x2: 410,
    y2: 175,
    stroke: "#d84a2d",
    strokeWidth: 5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.a9be25760e3561deada8d8abae181bf2.svg";
export { ForwardRef as ReactComponent };